export enum HealthGoalType {
  TRYING_TO_CONCEIVE = 'Trying to Conceive',
  PERIMENOPAUSE_TRACKING = 'Perimenopause Tracking',
  HORMONE_OPTIMIZATION = 'Hormone Optimization',
}
